import { render } from "./trustBottomSlide.vue?vue&type=template&id=0c718142&scoped=true"
import script from "./trustBottomSlide.vue?vue&type=script&lang=js"
export * from "./trustBottomSlide.vue?vue&type=script&lang=js"

import "./trustBottomSlide.vue?vue&type=style&index=0&id=0c718142&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c718142"]])

export default __exports__